import { TemplateApiModel } from './template.model';

export type BlockApiModel = {
  id: number;
  name: string;
};

export type WithTemplates = BlockApiModel & { templates: TemplateApiModel[] };

export enum BlockRelationship {
  TEMPLATES = 'TEMPLATES',
}
